import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';

import { KebabCaseModule } from '~shared/pipes';

import { BasePageModule } from '~shared/modules/base-page/base-page.module';

import { BreadcrumbsModule } from '~shared/components/breadcrumbs/breadcrumbs.module';

import { SeoModule } from '~shared/modules/seo/seo.module';

import { CustomHubRoutingModule } from './custom-hub.routing.module';
import {
  CustomHubComponent,
  CustomHubCardComponent,
  CustomHubGridComponent,
  BestSellingProductsListComponent,
  LastDealsProductsListComponent,
  CustomPageInfoComponent,
} from './components';
import { StoreModule } from '@ngrx/store';
import { CUSTOM_HUB_FEATURE_NAME } from './store/feature-name';
import { BestSellingProductsEffects, HubEffects, customHubReducers, LastDealsProductsEffects } from './store';
import { EffectsModule } from '@ngrx/effects';

import { ProductsGridModule } from '~shared/modules/products-grid/products-grid.module';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';
import { AppProductCarouselModule } from '~shared/components/app-product-carousel/app-product-carousel.module';
import { StoryblokSeoModule } from '~shared/modules/storyblok-seo/storyblok-seo.module';

@NgModule({
  declarations: [
    CustomHubComponent,
    CustomHubCardComponent,
    CustomHubGridComponent,
    BestSellingProductsListComponent,
    LastDealsProductsListComponent,
    CustomPageInfoComponent,
  ],
  providers: [],
  //TODO check the list of imports module when we finish
  imports: [
    CommonModule,
    CustomHubRoutingModule,
    StoreModule.forFeature(CUSTOM_HUB_FEATURE_NAME, customHubReducers),
    EffectsModule.forFeature([HubEffects, BestSellingProductsEffects, LastDealsProductsEffects]),
    SeoModule,
    StoryblokSeoModule,
    MmFlexLayoutModule,
    TranslateModule,
    QaLocatorsModule,
    KebabCaseModule,
    BasePageModule,
    BreadcrumbsModule,
    FlexModule,
    ProductsGridModule,
    MmExpansionModule,
    AppProductCarouselModule,
  ],
})
export class CustomHubModule {}
